import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import './Users.css';

const Users = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterActive, setFilterActive] = useState('');

  const { data, isLoading, error } = useQuery({
    queryKey: ['users', searchTerm, filterActive],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (searchTerm) params.append('search', searchTerm);
      if (filterActive) params.append('isActive', filterActive);
      const response = await api.get(`/users?${params}`);
      return response.data.data;
    }
  });

  const users = data?.users || [];
  const pagination = data?.pagination;

  const formatDateTime = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleString('es-CO');
  };

  if (isLoading) return <div className="users-loading">Cargando usuarios...</div>;
  if (error) {
    return (
      <div className="users-error">
        <p>Error al cargar usuarios. Verifica que el backend Node esté ejecutándose.</p>
        <p className="error-detail">{error.message}</p>
      </div>
    );
  }

  return (
    <div className="users-page">
      <div className="page-header">
        <h2>Usuarios</h2>
        <p className="page-subtitle">Gestiona los usuarios del sistema</p>
      </div>

      <div className="filters-section">
        <input
          type="text"
          placeholder="Buscar por nombre o email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <select
          value={filterActive}
          onChange={(e) => setFilterActive(e.target.value)}
          className="filter-select"
        >
          <option value="">Todos los estados</option>
          <option value="true">Activos</option>
          <option value="false">Inactivos</option>
        </select>
      </div>

      <div className="users-list">
        <table className="users-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Rol</th>
              <th>Empresa</th>
              <th>Estado</th>
              <th>Último acceso</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan={6} className="empty-state">
                  No hay usuarios registrados
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id}>
                  <td>
                    <strong>{user.fullName || `${user.firstName} ${user.lastName}`}</strong>
                  </td>
                  <td>{user.email}</td>
                  <td>
                    <span className="role-badge">{user.role?.name || '—'}</span>
                  </td>
                  <td>{user.company?.name || '—'}</td>
                  <td>
                    <span className={`status-badge ${user.isActive ? 'active' : 'inactive'}`}>
                      {user.isActive ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>{formatDateTime(user.lastLogin)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {pagination && pagination.totalPages > 1 && (
          <div className="pagination-info">
            Página {pagination.page} de {pagination.totalPages} ({pagination.total} usuarios)
          </div>
        )}
      </div>
    </div>
  );
};

export default Users;
